// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ProposalSource = zod.object({
  "file_id": zod.uuid(),
  "quote": zod.string()
});

export type ProposalSource = zod.input<typeof ProposalSource>;
export type ProposalSourceOutput = zod.output<typeof ProposalSource>;
